import { Injectable } from '@angular/core';
import { DashboardService } from './dashboard.service';
import { PARAMETER_CONFIGS, ParameterConfig } from 'src/app/shared/constant';
import { MinMaxHelper } from '../helpers/min-max.helper';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class MinMaxService {

    constructor(private dashboardService: DashboardService) { }

    /**
     * Fetches data from the API and processes it to find Min/Max values.
     * @param deviceId The device ID to fetch data for.
     * @param date The date string (YYYY-MM-DD).
     * @param fixedInterval The timeframe interval (e.g. 1s, 1m, 5m, etc).
     * @returns Observable containing the processed parameters list.
     */
    public getMinMaxData(deviceId: any, date: String, fixedInterval: string = '1s'): Observable<ParameterConfig[]> {
        const parameters = PARAMETER_CONFIGS.map(c => c.key?.replace('val_', '') || '');

        const body = {
            'action': 'getChartDataByAccount',
            'user_id': [localStorage.getItem('user')],
            'device_id': [deviceId],
            'date': date,
            'fixed_interval': fixedInterval,
            'parameters': parameters
        };

        return this.dashboardService.httpPost(body).pipe(
            map((res: any) => {
                const buckets = res?.data?.buckets?.[0]?.date_agg?.buckets || [];

                // Initialize fresh list from helper
                const parametersList = MinMaxHelper.initializeParameters();

                if (buckets.length > 0) {
                    MinMaxHelper.processBuckets(buckets, parametersList);
                    MinMaxHelper.sanitizeMinMaxValues(parametersList);
                } else {
                    MinMaxHelper.resetValuesToZero(parametersList);
                }

                // Remove key after processing as previously required
                parametersList.forEach(p => delete p.key);

                return parametersList;
            })
        );
    }
}
